import { useEffect } from 'react';

const HIGHLIGHT_CLASS = 'order-history-item--located';
const LOOKUP_INTERVAL = 200;
const LOOKUP_TIMEOUT = 15000;
const HIGHLIGHT_DURATION = 3000;

export const orderHistoryJobAnchorId = (jobId: number | string) =>
  `order-history-job-${jobId}`;

/**
 * Scrolls to the job a deep link asked for and marks it, once the filtered list has rendered it.
 * The list arrives asynchronously, so the anchor is polled for rather than read once.
 */
export const useLocateOrderHistoryJob = (jobId?: string) => {
  useEffect(() => {
    if (!jobId) {
      return;
    }

    let located: HTMLElement | undefined;
    let highlightTimer: number | undefined;
    let elapsed = 0;

    const lookup = window.setInterval(() => {
      const element = document.getElementById(orderHistoryJobAnchorId(jobId));
      if (element) {
        window.clearInterval(lookup);
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
        element.classList.add(HIGHLIGHT_CLASS);
        located = element;
        highlightTimer = window.setTimeout(() => {
          element.classList.remove(HIGHLIGHT_CLASS);
        }, HIGHLIGHT_DURATION);
        return;
      }
      elapsed += LOOKUP_INTERVAL;
      if (elapsed >= LOOKUP_TIMEOUT) {
        window.clearInterval(lookup);
      }
    }, LOOKUP_INTERVAL);

    return () => {
      window.clearInterval(lookup);
      if (highlightTimer !== undefined) {
        window.clearTimeout(highlightTimer);
      }
      located?.classList.remove(HIGHLIGHT_CLASS);
    };
  }, [jobId]);
};
